<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-container>
      <v-row>
        <v-col cols="12" md="12">
          <!-- <v-autocomplete
            :label="$t('choose_category')"
            :no-data-text="$t('no_data_available')"
            v-model="request.category"
            :items="categoryItems"
            :loading="categoryIsLoading"
            :search-input.sync="searchCategory"
            item-value="id"
            item-text="name"
            @click="searchCategory = ''"
            required
            :rules="required"
          ></v-autocomplete> -->
        </v-col>
        <v-col cols="12" md="12">
          <v-list-item>
            <v-list-item-content>
              <v-progress-circular v-if="showProgressBar" indeterminate color="primary">
              </v-progress-circular>
              <v-list-item-title v-else v-for="(item, index) in languageItems" :key="index">
                {{ item.name }}
                <div class="order-group">
                  <v-checkbox v-if="item.status === 'order_now'" v-model="item.request.specialized">
                    <template v-slot:label>
                      <span class="custom_input">{{ $t('specialized') }}</span>
                    </template>
                  </v-checkbox>
                  <v-btn ref="activator" :disabled="item.disabled" color="primary" @click="submit(item.request, item.status, item.orderInfo, item.name)">
                    {{ $t(item.status) }}
                  </v-btn>
                </div>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="12" md="12"> </v-col>
      </v-row>
      <v-row>
        <v-spacer></v-spacer>
        <v-col cols="12" md="4" class="circle-center"> </v-col>
        <v-spacer></v-spacer>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import axios from 'axios';
import i18n from '@/i18n';
import countries from 'i18n-iso-countries';
countries.registerLocale(require('i18n-iso-countries/langs/en.json'));
countries.registerLocale(require('i18n-iso-countries/langs/pl.json'));

import languages from '@cospired/i18n-iso-languages';
languages.registerLocale(require('@cospired/i18n-iso-languages/langs/en.json'));
languages.registerLocale(require('@cospired/i18n-iso-languages/langs/pl.json'));

export default {
  name: 'OrderForm',
  props: {
    url: {
      type: String,
      default: '',
    },
    lang: {
      type: String,
      default: 'Polish',
    },
    postId: {
      type: Number,
      default: 1,
    },
  },
  data: () => ({
    valid: false,
    categoryIsLoading: false,
    categoryItems: [],
    languageIsLoading: false,
    languageItems: {},
    response: {},
    searchCategory: null,
    required: [v => !!v || i18n.t('required')],
    showProgressBar: true,
  }),
  watch: {
  //   searchCategory(val) {
  //     if (this.categoryItems.length > 0) return;
  //     if (this.categoryIsLoading) return;

  //     this.categoryIsLoading = true;

  //     axios
  //       .get(`${this.url}?action=getTranslationsCategories&query=${val}`)
  //       .then(res => {
  //         this.categoryItems = Object.values(res.data);
  //       })
  //       .catch(err => console.log(err))
  //       .finally(() => (this.categoryIsLoading = false));
  //   },
  },
  methods: {
    errorHandler(message) {
      this.color = 'error';
      this.message = this.$t(message);
      this.dialog = false;
      this.snackbar = true;
    },
    submit(item, status, orderInfo, targetLangName) {
      if (this.$refs.form.validate()) {
        this.showProgressBar = true;
        let { postId } = this;
        let data = Object.assign({}, item, { postId: postId });
        if (status == 'order_now') {
          axios
            .post(`${this.url}?action=createTurbotranslateOrder`, JSON.stringify(data))
            .then(res => {
              if (res.data.id) {
                const response = Object.assign(res.data, { targetLangName });
                this.$emit('evaluation', response);
              } else {
                this.$emit('error', res.data.message);
              }
            })
            .catch(err => {
              this.$emit('error', err);
            });
        } else {
          this.$emit('evaluation', orderInfo);
        }
      }
    },
    searchLanguages() {
      return axios
        .get(`${this.url}?action=getAvailablePairs&source=${this.lang}&post_id=${this.postId}`)
        .then(res => {
          this.languageItems = res.data.map(el => {
            let { lang_to } = el;
            let code = languages.getAlpha2Code(lang_to.name, 'en');
            let name = languages.getName(code, 'pl');
            return {
              name: name ? name : lang_to.name,
              request: {
                category: 40,
                specialized: false,
                target_lang: {
                  id: lang_to.id,
                },
              },
            };
          });

          this.languageItems = this.languageItems.filter(el => el.name.length > 0);
        })
        .catch(err => console.log(err));
    },
    doesTranslationExists() {
      return axios
        .get(`${this.url}?action=getPendingPost&id=${this.postId}`)
        .then(res => {
          for (const el of Object.values(this.languageItems)) {
            this.$set(el, 'status', 'order_now');
            if (res.data.status !== false) {
              const found = res.data.find(data => el.request.target_lang.id == data.lang);
              if (found) {
                this.$set(el, 'orderInfo', found);
                if(found.status != 'finished') {
                  this.$set(el, 'status', 'in_progress')
                  this.$set(el,'disabled','disabled')
                } else {
                  this.$set(el,'status', 'finished')
                  this.$set(el,'disabled','disabled')
                }
              }
            }
          }
        })
        .catch(err => {
          this.errorHandler(err);
        });
    },
    btnText(resStatus) {
      if (resStatus) {
        this.status = this.$t(resStatus);
      }
    },
  },
  async mounted() {
    await this.searchLanguages();
    await this.doesTranslationExists();
    this.showProgressBar = false;
  },
};
</script>
<style scoped>
.v-progress-circular {
  margin: 0 auto;
}
.circle-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.v-list-item__title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  background-color: #e4e4e46e;
  border-radius: 5px;
  text-transform: uppercase;
  font-weight: 500;
  margin-bottom: 5px;
}
.order-group {
  display: flex;
  flex-direction: column-reverse;
  align-items: flex-end;
}
.custom_input {
  font-size: 12px;
  margin-right: 10px;
}
</style>
